<template>
    <div>
        <el-form :inline="true" :model="formInline" class="demo-form-inline select-wrap" :size="GCONFIG.styleElFormSize">
            <el-form-item>
                <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
            </el-form-item>
            <el-form-item label="页面标题">
                <el-input v-model="formInline.pageTitle" placeholder="页面标题"></el-input>
            </el-form-item>
            <el-form-item label="页面名称">
                <el-input v-model="formInline.pageName" placeholder="页面名称"></el-input>
            </el-form-item>
            <el-form-item label="分享标题">
                <el-input v-model="formInline.shareTitle" placeholder="分享标题"></el-input>
            </el-form-item>
            <el-form-item label="平台">
                <el-select v-model="formInline.platformId"  placeholder="平台" >
                    <el-option v-for="item in platformData"
                               :key="item.platformId"
                               :label="item.platformName"
                               :value="item.platformId">
                    </el-option>
                </el-select>
            </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="getList">查询</el-button>
            <el-button type="success" @click="handleAdd">新增</el-button>
        </el-form-item>
        </el-form>


        <el-table :data="listData" stripe border center :size="GCONFIG.styleTableSize" v-loading="loading" >
              <!--  <el-table-column type="selection" width="55"></el-table-column>-->
                <el-table-column type="index" label="序号" width="50"></el-table-column>
                <el-table-column prop="platformId" label="平台" :formatter="platformShow" width="100"></el-table-column>
                <el-table-column prop="pageTitle" label="页面标题"  width="120"></el-table-column>
                <el-table-column prop="pageName" label="页面名称" width="150"></el-table-column>
                <el-table-column prop="shareTitle"  label="分享标题" ></el-table-column>
                <el-table-column prop="shareDigest"  label="分享摘要"  ></el-table-column>
            <el-table-column prop="shareUrl"  label="分享链接"   width="160">
                <template slot-scope="scope">
                    <a :href="scope.row.shareUrl" target="_blank">{{scope.row.shareUrl}}</a>
                </template>
            </el-table-column>
            <el-table-column prop="shareImageUrl"  label="分享图片链接"   width="120">
                <template slot-scope="scope">
                    <img :src="scope.row.shareImageUrl" width="70" height="70"/>
                </template>
            </el-table-column>

            <el-table-column prop="defaultConfig"  label="是否默认" :formatter="defaultConfigShow"   width="70"></el-table-column>

                <el-table-column prop="updateTime" label="更新日期"   width="150"></el-table-column>
                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <el-button type="primary"  size="mini"   @click="handleEdit(scope.row)">修改</el-button>
                        <el-button type="warning"  size="mini"  @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="formInline.currentPage"
                        :page-sizes="GCONFIG.pageSizes"
                        :page-size="formInline.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="formInline.recordsTotal">
                </el-pagination>
            </div>

        <el-dialog title="新增/修改" :visible.sync="dialogFormVisible" center>
            <el-form :model="form" label-width="80px">
                <el-form-item label="id" :hidden="true">
                    <el-input v-model=form.id ></el-input>
                </el-form-item>
                <el-form-item label="平台">
                    <el-select v-model="form.platformId"  placeholder="平台" :disabled="platformDisabled">
                        <el-option v-for="item in platformData"
                                   :key="item.platformId"
                                   :label="item.platformName"
                                   :value="item.platformId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="页面标题">
                    <el-input type="text" v-model=form.pageTitle clearable  placeholder="页面标题" maxlength="40"
                              show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="页面名称">
                    <el-input type="text" v-model=form.pageName clearable  placeholder="页面名称" maxlength="40"
                              show-word-limit></el-input>
                    如：http://wx.lechun.cc/pages/active/milkCard/my_milk_card.html，取：my_milk_card
                </el-form-item>
                <el-form-item label="标签说明">
                    <el-input type="textarea" v-model=tagContent  autosize clearable disabled=true  placeholder="页面名称" maxlength="40"
                              show-word-limit></el-input>
                </el-form-item>
                <el-form-item label="分享标题">
                    <el-input type="text" v-model=form.shareTitle clearable  placeholder="分享标题" maxlength="50"
                              show-word-limit></el-input>
                    支持标签，支持标签见以上标签说明，举例：{nickName}邀请你购买{productName}
                </el-form-item>
                <el-form-item label="分享摘要" >
                    <el-input type="textarea"
                              :rows="5" v-model=form.shareDigest clearable  placeholder="分享摘要" maxlength="200"
                              show-word-limit></el-input>
                    支持标签，支持标签见以上标签说明，举例：{nickName}邀请你购买{productName}
                </el-form-item>
                <el-form-item label="分享链接" >
                    <el-input type="text" v-model=form.shareUrl clearable  placeholder="分享链接" maxlength="255"
                              show-word-limit></el-input>
                    如不配置，自动分享当前页面
                </el-form-item>
                <el-form-item label="商品图" >
                    <el-input type="text" v-model=form.shareImageUrl1 clearable  placeholder="只支持促销、单品、套装" maxlength="255"
                              show-word-limit></el-input>
                    支持图片标签，支持标签见以上标签说明，支持11~17项，举例：{picSmall[0]}表示取第1个小图
                </el-form-item>
                <el-form-item label="默认图片">
                    <el-button @click="selectUpload">上传图片</el-button>
                    <el-image
                            class="select-pic"
                            style="width: 100px; max-height: 200px"
                            :src="selectImageUrl"
                            :preview-src-list="[selectImageUrl]">
                    </el-image>
<!--                    <uploadComponents v-model="form.shareImageUrl" :urlType="2"></uploadComponents>-->
                </el-form-item>
                <el-form-item label="是否默认" >
                    <el-select v-model="form.defaultConfig" disabled=true placeholder="是否默认">
                        <el-option v-for="item in defaultConfigData"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>



                <el-form-item>
                    <el-button-group>
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="save(form)">确 定</el-button>
                    </el-button-group>

                </el-form-item>
            </el-form>

        </el-dialog>
        <picDialog :picType="activeNo" :fromState="'onlyOne'" @selectPicOne="selectPicOne"></picDialog>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import {getPlatformList2,getShareList,deleteShare,saveShare,getShare} from '../../api/api';
    import uploadComponents from '@/components/upload';
    import picDialog from '@/components/pic_dialog/pic_list'
    //定义组件
    export default{
        data(){
            return {
                listData:[],
                platformData:[],
                defaultConfigData:[{"id":0,"name":"否"},{"id":1,"name":"是"}],
                loading:true,
                dialogFormVisible:false,
                form:{"id":null,"pageTitle":"","pageName":"","shareTitle":"",
                    "shareDigest":"","shareUrl":"","shareImageUrl":"","platformId":1,"defaultConfig":0},
                formInline:{
                    currentPage: 1,
                    pageSize: 15,
                    recordsTotal: 0,
                    platformId:1,
                },
                platformDisabled:false,
                tagContent:"分享标题和分享摘要支持以下标签，直接复制标签名和{}到文本框中即可\n"+
                            "1、{nickName} 取用户昵称\n"+
                            "2、{proName} 单品商品详情页，如果是单品取单品名称\n"+
                            "3、{proNameSx} 单品商品详情页，如果是单品取单品简称\n"+
                            "4、{proOtherName} 单品商品详情页，如果是单品取单品别名\n"+
                "5、{proTitle} 单品商品详情页，如果是单品取单品标题\n"+
                "6、{proSummary} 单品商品详情页，如果是单品取单品名称摘要\n"+
                "7、{promotionName} 促销商品详情页，如果是促销取促销名称\n"+
                "8、{groupName} 套装商品详情页，如果是套装取套装名称\n"+
                "9、{groupOtherName} 套装商品详情页，如果是套装取套装别名\n"+
                "10、{summary} 套装商品详情页，如果是套装取套装概述\n"+
                    "以下支持商品图字段，[0]代表取第几个，0表示第一个，以此类推，如不存在自动取第1个，第一个也不存在取默认图片\n"+
                "11、{picBig[0]} 产品图，详情页大图\n"+
                "12、{picList[0]} 产品图，首页列表图\n"+
                "13、{picNutrition[0]} 产品图，营养图\n"+
                "14、{picBuy[0]} 产品图，长期订购图\n"+
                "15、{picSmall[0]} 产品图，小图\n"+
                "16、{picDetail[0]} 产品图，详情页图\n"+
                "17、{picRecommend[0]} 产品图，推荐图\n",
                activeNo:'',
                selectImageUrl:''



            }
        },
        //挂载时候执行
        mounted(){
            getPlatformList2(this.formInline).then((res) => {
                this.platformData=res.data;
                this.formInline.platformId=res.data[0].platformId;
                //初始化首页数据
                this.getList();
            });
        },
        components:{
            uploadComponents,picDialog
        },
        methods:{
            //定义查询方法
            getList(){
                getShareList(this.formInline).then((res) => {
                    this.loading = false;
                    this.formInline.recordsTotal = res.data.value.total;
                    this.listData = res.data.value.list;

                })
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            handleDel(row){
                if(confirm("确定删除分享:"+row.title+"吗？")) {
                    deleteShare({id: row.id}).then((res) => {
                        if (res.data.status == 200) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList(this.currentPage, this.pageSize);
                        } else {
                            this.$message({
                                showClose: true,
                                message: res.data.message,
                                type: 'error'
                            });
                        }

                    })
                }
            },
            handleAdd(){
                //var d={id:0};
                this.dialogFormVisible = true;
                this.form.id=null;
                this.form.pageTitle='';
                this.form.pageName='';
                this.form.shareTitle='';
                this.form.shareDigest='';
                this.form.shareUrl='';
                this.form.shareImageUrl='';
                this.form.defaultConfig=0;
                this.form.creatTime=null;
                this.form.updateTime=null;
                this.form.operater='';
                this.form.operater='';
                this.form.platformId=1;
                this.platformDisabled=false;
            },
            handleEdit(data){
                this.dialogFormVisible = true;
                this.platformDisabled=true;
                //得到实体
                getShare({id:data.id}).then((res) => {
                    //console.log(res.data);
                    if(res.data.value!=undefined) {
                        this.form = res.data.value;
                        this.selectImageUrl=this.form.shareImageUrl;
                    }
                });
            },
            save(data){
                console.log(data);
                if(data.pageTitle==""){
                    this.$message({
                        message:"请输入页面标题",
                        type:'error'
                    });
                    return;
                }
                if(data.pageName==""){
                    this.$message({
                        message:"请输入页面名称",
                        type:'error'
                    });
                    return;
                }
                if(data.shareTitle===""){
                    this.$message({
                        message:"请输入分享标题",
                        type:'error'
                    });
                    return;
                }
                if(data.shareDigest==""){
                    this.$message({
                        message:"请输入分享摘要",
                        type:'error'
                    });
                    return;
                }
                saveShare(data).then((res) => {
                    //console.log(res);
                    if(res.data.success){
                        this.$message({
                            message:res.data.message,
                            type:'success'
                        });
                        this.getList(this.currentPage, this.pageSize);
                        this.dialogFormVisible=false;
                    }else{
                        this.$message({
                            message:res.data.message,
                            type:'error'
                        });
                    }
                });
            },
            defaultConfigShow(row, column, cellValue) {
                for(var key in this.defaultConfigData){
                    if(this.defaultConfigData[key].id==cellValue) {
                        return this.defaultConfigData[key].name;
                    }
                }
            },
            platformShow(row,column,cellValue){
                for(var key in this.platformData){
                    if(this.platformData[key].platformId==cellValue) {
                        return this.platformData[key].platformName;
                    }
                }
            },
            returnHistory(){
                window.history.back()
            },
            selectUpload(){
                //this.dialogFormVisible=false;
                this.$store.commit('SET_PIC_DIALOG',true)

            },
            selectPicOne(obj){
                console.log(obj)
                this.$store.commit('SET_PIC_DIALOG',false)

                this.form.shareImageUrl = obj.imagePath
                this.selectImageUrl = obj.allImagePath
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/views/distribution/shareList.vue